export const ROUTES = {
    root: '/',
    Membership: {
        auth: '/membership/auth',
        emailVerification: '/membership/email-verification',
        otp: '/membership/otp',
        requestPasswordReset: '/membership/request-password-reset',
        resetPassword: '/membership/reset-password',
    },
    Table: {
        root: '/table',
    },
    Order: {
        root: '/order/:orderId',
        search: '/order/search',
        number: '/order/number/:orderNumber',
        complete: '/order/:orderId/complete',
        receipt: '/order/number/:orderNumber/receipt',
        history: '/order-history',
    },
    CheckoutAssistant: {
        root: '/checkout-assistant',
        login: '/checkout-assistant/login',
    },
    Payment: {
        root: '/order/:orderId/payment/:paymentIntentId/:clientSecret',
        check: '/order/:orderId/check-payment/:paymentIntentId/:clientSecret',
    },
    AdvanceTakeawayPayment: {
        root: '/order/:orderId/advance-takeaway-payment',
    },
    ForceRating: {
        root: '/force-rating',
    },
}

// Configuration for NavBar visibility
export const HIDE_NAVBAR_PATHS = ['advance-takeaway-payment', 'order/', 'payment', 'payment-complete', 'checkout-assistant']
